import { Input } from 'antd';
import { FC, ReactNode, useEffect, useState } from 'react';
import './autotest.scss';

/* -------------------------------------------------------------------------------- *\
|                               CalendarPage
\* -------------------------------------------------------------------------------- */
export const AutotestPage: FC<{ children?: ReactNode }> = ({ children }) =>
{
    const [value, setValue] = useState<string>("");
    const [lines, setLines] = useState<string[]>([]);

    function isHex(num: string) {
        return Boolean(num.match(/^[0-9a-f]+$/i))
    }

    useEffect(() => {
        var v = value;
        var valid: boolean = false;
        if (v.length >= 1 && v.length <= 3 && isHex(v))
        {
            valid = true;
        }

        var results: string[] = [];
        if (valid)
        {
            const n = Number("0x" + v);

            if (n & 0x01) results.push("Modem");
            if (n & 0x02) results.push("GPS");
            if (n & 0x04) results.push("UWB");
            if (n & 0x08) results.push("IMU");
            if (n & 0x10) results.push("BQ");
            if (n & 0x20) results.push("Ble");
            if (n & 0x40) results.push("Aux UART");
            if (n & 0x80) results.push("Memory");
            if (n & 0x100) results.push("Button");
            if (n & 0x200) results.push("Fuel Gauge");
            if (n & 0x400) results.push("Battery not detected");
            /*
                SET_ERROR_CODE(s_modemTestResult_b, 0);
                SET_ERROR_CODE(s_gpsTestResult_b, 1);
                SET_ERROR_CODE(s_uwbTestResult_b, 2);
                SET_ERROR_CODE(s_imuTestResult_b, 3);
                SET_ERROR_CODE(s_bqTestResult_b, 4);
                SET_ERROR_CODE(s_bleTestResult_b, 5);
                SET_ERROR_CODE(s_auxChipUartTestResult_b, 6);
                SET_ERROR_CODE(s_memoryTestResult_b, 7);
                SET_ERROR_CODE(s_buttonTestResult_b, 8);
                SET_ERROR_CODE(s_fuelGaugeTestResult_b, 9);

            */
        }
        else
        {
            results.push("invalid value");
        }
        setLines(results);
        // eslint-disable-next-line
    }, [value]);

    return (
        <div className="autotest">
            <h1><em>Autotest</em></h1>
            <div className="autotest__input">
                <div className='autotest__input__label'>Error code : 0x</div>
                <Input type="text" placeholder='00' value={value} onChange={e => setValue(e.target.value)} />
            </div>
            <div className="autotest__results">
                <div className='autotest__results__label'>Results:</div>
                <div className='autotest__results__lines'>
                {
                    lines.map((line, index) => (
                        <div key={index}>{line}</div>
                    ))
                }
                </div>
            </div>
        </div>
    );
}
